"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            apps: [],
            more: false,
            showViewApp: false,
            suggestions: [],
            fetching: false
        };
        this.fetchApps();
    },
    onDisplayApp: function (dataset) {
        this.state.showViewApp = dataset && dataset.__app || false;
    },
    fetchApps: async function () {
        this.state.fetching = true;
        try {
            const {error, message, apps, more} = await Request(this.state.more || '/app/list/all');
            if (error)
                return console.log('Error Fetching Apps: ', message);
            if (more) {
                this.state.more = more;
                this.state.apps = [
                    ...this.state.apps,
                    ...apps
                ];
            }
            this.state.apps = apps.map(__app => {
                const {type, name, description, status, configs, created, updated} = __app;
                return {
                    __app,
                    type,
                    status,
                    icon: 'cube-alt',
                    info: `<b>${ name }</b><br><p class="mb-0 font-small-4 text-muted">${ description }</p>`,
                    mode: configs.mode,
                    datetime: `<b>Created</b> ${ formatDate(created.at, 'calendar') } ${ updated ? `<br> <b>Updated</b> ${ formatDate(updated.at, 'calendar') }` : '' }`
                };
            });
        } catch (error) {
            console.log('Error Fetching Apps: ', error);
        }
        this.state.fetching = false;
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({type, name, description}) => {
            return {
                title: name,
                subtitle: description,
                status: type
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Apps/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    SearchBar_template = require("../../../components/SearchBar/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Datatable_template = require("../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    ViewApp_template = require("./components/ViewApp.marko"),
    ViewApp_tag = marko_loadTag(ViewApp_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "col-12"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("b4802f"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      });

const tableFormat = [
	{ key: 'icon', label: '#', type: 'icon', col: '1', style: 'text-center' },
	{ key: 'info', label: 'Name' },
	{ key: 'type', label: 'Type', col: '2' },
	{ key: 'status', label: 'Status', col: '2', style: 'text-primary' },
	{ key: 'mode', label: 'Current Mode', col: '2', wsadapt: { hs: 'd-none' } },
	{ key: 'datetime', label: 'Date & Time', wsadapt: { qs: 'd-none', hs: 'd-none' } }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        Row_tag({
            class: "m-0",
            renderBody: function(out) {
              WSAdapt_tag({
                  ns: "col-5",
                  qs: "col-7",
                  hs: "col-7",
                  renderBody: function(out) {
                    SearchBar_tag({
                        icon: "bx-search",
                        target: "app",
                        minLength: 3,
                        suggestions: state.suggestions,
                        placeholder: Locale("Find a App")
                      }, out, __component, "3", [
                      [
                        "blur",
                        "onSearchDismiss",
                        false
                      ],
                      [
                        "result",
                        "onSearchResult",
                        false
                      ],
                      [
                        "select",
                        "onSelectSuggestion",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "2");

              WSAdapt_tag({
                  class: "col",
                  renderBody: function(out) {
                    route_link_tag({
                        href: "/create-app",
                        class: "btn btn-primary btn-lg float-right ml-25",
                        renderBody: function(out) {
                          Locale_tag({
                              text: "Create App"
                            }, out, __component, "6");
                        }
                      }, out, __component, "5");
                  }
                }, out, __component, "4");

              out.be("div", marko_attrs0, "7", component);

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              Datatable_tag({
                  format: tableFormat,
                  data: state.apps,
                  pagination: 10,
                  stripped: true,
                  loading: state.fetching,
                  class: "w-100 theme-bg"
                }, out, __component, "10", [
                [
                  "canload",
                  "fetchApps",
                  false
                ],
                [
                  "select",
                  "onDisplayApp",
                  false
                ]
              ]);

              out.ee();
            }
          }, out, __component, "1");

        if (state.showViewApp) {
          ViewApp_tag({
              app: state.showViewApp
            }, out, __component, "11", [
            [
              "refresh",
              "fetchApps",
              false
            ],
            [
              "dismiss",
              "onDisplayApp",
              false,
              [
                  false
                ]
            ]
          ]);
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
